exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main-logo  {\n  top: 10px;\n}\n.toolbar {\n  position: relative;\n}\n.toolbar .v-toolbar__image {\n  filter: brightness(82%);\n}\n.navbar-icon {\n  display: block;\n}\n.navbar-text {\n  display: block;\n}\n.language-select-dial {\n  bottom: -22px;\n}\n", ""]);

// exports
